import React from 'react';

function ToolIcon({ type, label }) {
  if (type === 'pattern') {
    return (
      <svg className="tool-icon-svg" role="img" aria-label={label} viewBox="0 0 32 32" fill="none">
        <path d="M5 24H27" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.35" />
        <path d="M7 21L12 15L17 18L25 8" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 10V22M15 7V20M22 6V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.65" />
        <path d="M7 13H11M13 11H17M20 10H24" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
      </svg>
    );
  }

  if (type === 'detective') {
    return (
      <svg className="tool-icon-svg" role="img" aria-label={label} viewBox="0 0 32 32" fill="none">
        <path d="M16 4L25 8V15C25 21.1 21.2 25.5 16 28C10.8 25.5 7 21.1 7 15V8L16 4Z" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
        <path d="M11 16A5 5 0 1 0 21 16A5 5 0 0 0 11 16Z" stroke="currentColor" strokeWidth="2" />
        <path d="M19.5 19.5L23 23" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        <path d="M13 16H19M16 13V19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" opacity="0.6" />
      </svg>
    );
  }

  return (
    <svg className="tool-icon-svg" role="img" aria-label={label} viewBox="0 0 32 32" fill="none">
      <path d="M6 9H26M6 23H26" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
      <path d="M9 16H23" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.45" />
      <path d="M10 23C10 18.5 13 17 16 17C19 17 22 15.5 22 9" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="10" cy="23" r="2" fill="currentColor" />
      <circle cx="22" cy="9" r="2" fill="currentColor" />
    </svg>
  );
}

export default ToolIcon;
